import React from 'react';

const CheckResultCircle = ({ bg }) => {
	return <i className={`fa-solid fa-circle ${bg}`}></i>;
};

export default CheckResultCircle;
